import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CompanyTemplateUploadBox from "../../CompanyTemplates/UploadBox";

const ui = {
  pageBg: "#f7f8fa",
  panel: "#ffffff",
  railBg: "#ffffff",
  border: "#e6e9ee",
  borderStrong: "#d9dee7",
  text: "#182230",
  muted: "#667085",
  subtle: "#98a2b3",
  soft: "#f8fafc",
  successBg: "#eefaf2",
  successBorder: "#b7e4c4",
  successText: "#17733b",
};

const CompanyTemplateDialog = ({
  open,
  onClose,
  companyId,
  disabled,
  onImported,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    PaperProps={{
      sx: {
        m: { xs: 1, sm: 2 },
        width: { xs: "calc(100% - 16px)", sm: "100%" },
        maxHeight: { xs: "calc(100% - 16px)", sm: "calc(100% - 64px)" },
      },
    }}
  >
    <DialogTitle sx={{ px: { xs: 1.5, sm: 3 }, pb: 0.75, fontSize: 16, fontWeight: 700 }}>
      <FormattedMessage id="admin.companyTemplateImport" />
    </DialogTitle>
    <DialogContent sx={{ px: { xs: 1.5, sm: 3 }, pt: 1 }}>
      <Typography sx={{ color: ui.muted, fontSize: 12, lineHeight: 1.5 }}>
        <FormattedMessage id="admin.companyTemplateDescription" />
      </Typography>
      <Typography sx={{ mt: 0.65, color: ui.subtle, fontSize: 11.1, lineHeight: 1.45 }}>
        <FormattedMessage id="admin.companyTemplateClarification" />
      </Typography>

      <Box
        sx={{
          mt: 1.6,
          pointerEvents: disabled || !companyId ? "none" : "auto",
          opacity: disabled || !companyId ? 0.45 : 1,
          "& > div": {
            width: "100% !important",
            marginTop: "0 !important",
            padding: "10px !important",
            borderColor: `${ui.borderStrong} !important`,
            bgcolor: `${ui.soft} !important`,
          },
        }}
      >
        <CompanyTemplateUploadBox
          companyId={companyId}
          embedded
          onImported={onImported}
        />
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: { xs: 1.5, sm: 3 }, pb: 1.5 }}>
      <Button onClick={onClose} sx={{ textTransform: "none" }}>
        <FormattedMessage id="btn.close" />
      </Button>
    </DialogActions>
  </Dialog>
);

CompanyTemplateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  onImported: PropTypes.func.isRequired,
};

CompanyTemplateDialog.defaultProps = {
  companyId: null,
};

CompanyTemplateDialog.displayName = "CompanyTemplateDialog";

export default CompanyTemplateDialog;
